/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./idp-call-back.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./idp-call-back.component";
import * as i3 from "@angular/router";
import * as i4 from "../app/shared/common/IDSVRAuthProviders/auth.service";
var styles_IdpCallBackComponent = [i0.styles];
var RenderType_IdpCallBackComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_IdpCallBackComponent, data: {} });
export { RenderType_IdpCallBackComponent as RenderType_IdpCallBackComponent };
export function View_IdpCallBackComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_IdpCallBackComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-idp-call-back", [], null, null, null, View_IdpCallBackComponent_0, RenderType_IdpCallBackComponent)), i1.ɵdid(1, 114688, null, 0, i2.IdpCallBackComponent, [i3.Router, i4.AuthService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var IdpCallBackComponentNgFactory = i1.ɵccf("app-idp-call-back", i2.IdpCallBackComponent, View_IdpCallBackComponent_Host_0, {}, {}, []);
export { IdpCallBackComponentNgFactory as IdpCallBackComponentNgFactory };
